import { makeAutoObservable } from "mobx";
import { ZSpecCommon } from "src/business/specification";
import { GroupChecked } from "src/components/ReactiveTable/utils/groupChecked";

import { AttrTransferPartStore } from "./AttrTransferPart/AttrTransferPartStore";
import { makeInitialSelection } from "./makeInitialSelection";

export class AttributesTransferStore {
  constructor(
    public readonly specs: ZSpecCommon[],
    initialAttrIds: string[],
  ) {
    this.currentSelection = makeInitialSelection(specs, initialAttrIds);
    // Left part = атрибуты, которые не включены
    this.left = new AttrTransferPartStore(
      specs,
      (uid) => this.currentSelection[uid] !== "all",
    );
    // Right part = то, что выбрано
    this.right = new AttrTransferPartStore(
      specs,
      (uid) => (this.currentSelection[uid] ?? "none") !== "none",
    );
    makeAutoObservable(this);
  }

  get selectedIds(): string[] {
    return Object.entries(this.currentSelection)
      .filter(([, check]) => check !== "none")
      .map(([id]) => id);
  }

  // Словарь начальных состояний выделения атрибутов: attribute.uid => GroupChecked
  // Несмотря на то что initialAttrIds даёт всего два состояния (выбран/не выбран),
  // тут уже есть для атрибутов типа list возможно состояние partial.
  currentSelection: Record<string, GroupChecked>;

  left: AttrTransferPartStore;

  right: AttrTransferPartStore;

  onLeftAction() {
    const newSel: string[] = [
      ...this.selectedIds,
      ...this.left.selectedRows.map(({ attr }) => attr.uid),
    ];
    this.currentSelection = makeInitialSelection(this.specs, newSel);
    this.left.buildList();
    this.right.buildList();
  }

  onRightAction() {
    const newSel = new Set(this.selectedIds);
    this.right.selectedRows.forEach(({ attr }) => {
      newSel.delete(attr.uid);
    });
    this.currentSelection = makeInitialSelection(
      this.specs,
      Array.from(newSel),
    );
    this.left.buildList();
    this.right.buildList();
  }
}
